import semver from 'semver';
import DocsSource from './DocsSource';

const branchBlacklist = ['docs'];
export default new DocsSource({
  id: 'main',
  name: 'Main library',
  global: 'Hypixel',
  repo: 'hypixel-api-reborn/hypixel-api-reborn',
  defaultTag: 'master',
  defaultClass: 'Client',
  branchFilter: branch => !branchBlacklist.includes(branch) && !branch.startsWith('dependabot/'),
  tagFilter: tag => semver.gte(tag, '6.0.0'),
});



// WEBPACK FOOTER //
// ./src/data/MainSource.js